import { render, staticRenderFns } from "./DemandUpsertForm.vue?vue&type=template&id=4df00b94"
import script from "./DemandUpsertForm.vue?vue&type=script&lang=js"
export * from "./DemandUpsertForm.vue?vue&type=script&lang=js"
import style0 from "./DemandUpsertForm.vue?vue&type=style&index=0&id=4df00b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports